import React from 'react'
import Companies from '../components/companies'

export default data => <Companies {...data} />
